import {
  Button,
  Form,
  notification,
  Select,
  Empty,
  Input,
  Drawer,
  Divider,
  Row,
  Col,
  DatePicker,
  Modal,
  Pagination,
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState, createContext } from "react";
import $axios from "../../services/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  moveToFirst,
  removeDiacritics,
  formatString,
} from "../../helpers/utils";
import {
  faLocationDot,
  faSearch,
  faAngleLeft,
  faArrowUp,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import ChooseHotel from "../Common/ChooseHotel";
import HotelItem from "../Common/HotelItem";
import "react-calendar/dist/Calendar.css";
import locale from "antd/es/date-picker/locale/vi_VN";
import "moment/locale/vi"; // Import locale tiếng Việt
import _ from "lodash";
import CalendarCustom from "../Common/Calendar/CalendarCustom";
import CustomInputNumber from "../Common/CustomInputNumber";
import axios from "axios";
const ReachableContext = createContext(null);

const Booking = ({ setLoading, loading, setStep }) => {
  const [countries, setCountries] = useState([]);
  const [filterCountries, setFilterCountries] = useState([]);
  const [chooseAddStep, setChooseAddStep] = useState(1);
  const [hotels, setHotels] = useState([]);
  const [openChooseHotel, setOpenChooseHotel] = useState(false);
  const [hotelSelected, setHotelSelected] = useState(null);
  const [form] = Form.useForm();
  const [provinces, setProvinces] = useState([]);
  const [filterProvinces, setFilterProvinces] = useState([]);
  // const [searched, setSearched] = useState(false);
  const [addPrice, setAddPrice] = useState(0);
  const [openDrawerChooseAdd, setOpenDrawerChooseAdd] = useState(false);
  const [openDrawerChooseHotel, setOpenDrawerChooseHotel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermHotel, setSearchTermHotel] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10); // Số item trên mỗi trang
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [displayHotels, setDisplayHotels] = useState([]); // Data to display
  const [valueCalendar, setValueCalendar] = useState(new Date());
  const [openCalendar, setOpenCalendar] = useState(false);
  const [typeCalendar, setTypeCalendar] = useState("");
  const [minDateCalendar, setMinDateCalendar] = useState(new Date());
  const [countryDetect, setCountryDetect] = useState("");
  const [provinceDetect, setProvinceDetect] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [defaultHotelIds, setDefaultHotelIds] = useState([
    "1975571",
    "1995217",
    "53697",
  ]);
  const [defaultHotel, setDefaultHotel] = useState([]);
  const [filterHotel, setFilterHotel] = useState([
    {
      value: "",
      name: "Tất cả",
    },
  ]);
  const [modal, contextHolder] = Modal.useModal();
  const [filter, setFilter] = useState({
    address: "",
    country: "",
    star: 6,
  });
  const [hotelSearch, setHotelSearch] = useState("");
  const [currentBatch, setCurrentBatch] = useState(0);
  const [hasMoreHotels, setHasMoreHotels] = useState(true);
  const [allHotelIds, setAllHotelIds] = useState([]);

  useEffect(() => {
    detectLocation();
    getCountries();
    getAddPrice();
    getDefaultHotel();
  }, []);

  useEffect(() => {
    if (filter.country && filter.address) {
      handleGetHotels();
      setHotelSearch("");
      setHasMoreHotels(true);
    }
  }, [filter]);

  useEffect(() => {
    if (hotelSearch) {
      setHasMoreHotels(true);
      setCurrentBatch(0);
    }
  }, [hotelSearch]);

  useEffect(() => {
    if (countries.length > 0 && countryDetect && provinceDetect) {
      const countryId = _.get(
        _.find(countries, (c) => c.name === countryDetect),
        "id",
        ""
      );
      if (countryId) {
        processLocationDetect(countryId);
      }
    }
  }, [countries, countryDetect, provinceDetect]);

  useEffect(() => {
    if (chooseAddStep === 1) {
      setFilterCountries(
        _.filter(countries, (item) => {
          return _.includes(
            _.toLower(removeDiacritics(`${item.name} ${item.code}`)),
            _.toLower(removeDiacritics(searchTerm))
          );
        })
      );
    }
    if (chooseAddStep === 2) {
      setFilterProvinces(
        _.filter(provinces, (item) => {
          return _.includes(
            _.toLower(removeDiacritics(item.name)),
            _.toLower(removeDiacritics(searchTerm))
          );
        })
      );
    }
  }, [searchTerm, chooseAddStep]);

  useEffect(() => {
    if (searchTermHotel) {
      setFilterHotel(
        _.filter(hotels, (item) => {
          return _.includes(
            _.toLower(removeDiacritics(item.name)),
            _.toLower(removeDiacritics(searchTermHotel))
          );
        })
      );
    } else {
      setFilterHotel([{ value: "", name: "Tất cả" }, ...hotels]);
    }
  }, [searchTermHotel]);

  const getDefaultHotel = async () => {
    try {
      const resHotel = await $axios.$post("/vn-travel/hotel-avail", {
        StayCheckIn: dayjs().add(1, "day").format("YYYY-MM-DD"),
        StayCheckOut: dayjs().add(2, "day").format("YYYY-MM-DD"),
        Nationality: "VN",
        OccupanciesAdults: 2,
        OccupanciesChildren: 0,
        LanguageCode: "vi",
        NumberOfUnits: 1,
        RealTimeSearch: true,
        Hotels: defaultHotelIds.map((id) => id.toString()),
      });
      const query = defaultHotelIds.map((id) => `propertyId=${id}`).join("&");
      const res = await $axios.$get(
        `/vn-travel/hotel-content/properties/content?${query}`
      );
      const hotelProperties = res.data.data.items;
      const hotels = resHotel.data.data.hotels;
      const processedHotels = hotels.map((hotel) => {
        const property = hotelProperties.find((h) => h.id === hotel.id);
        const rooms = property.rooms;
        if (property) {
          delete property.rooms;
        }
        if (hotel.status !== "NoRoom") {
          hotel.rooms = hotel.rooms.map((room) => {
            room.info = _.find(rooms, (r) => r.id == room.roomTypeCode) || {};
            if (hotel.status !== "NoRoom") {
              room.rates = room.rates.map((rate) => {
                rate["rateAfterTaxTotalNew"] =
                  rate["rateAfterTaxTotal"] + addPrice;
                rate["rateBeforeTaxTotalNew"] =
                  rate["rateBeforeTaxTotal"] + addPrice;
                return rate;
              });
              room["minPrice"] = _.minBy(
                room.rates,
                "rateAfterTaxTotalNew"
              ).rateAfterTaxTotalNew;
              room["maxPrice"] = _.maxBy(
                room.rates,
                "rateAfterTaxTotalNew"
              ).rateAfterTaxTotalNew;
            }
            return room;
          });
          hotel["minPrice"] = Math.min(...hotel.rooms.map((r) => r.minPrice));
          hotel["maxPrice"] = Math.max(...hotel.rooms.map((r) => r.maxPrice));
        } else {
          hotel.rooms = rooms;
        }
        return _.merge({}, hotel, property ? property : {});
      });
      const sortedHotels = processedHotels.sort((a, b) => {
        if (a.status === "Success" && b.status !== "Success") return -1;
        if (a.status !== "Success" && b.status === "Success") return 1;
        return 0; // giữ nguyên thứ tự nếu cả hai đều là "Success" hoặc đều không phải
      });
      setDefaultHotel(sortedHotels);
    } catch (error) {
    } finally {
    }
  };

  const processLocationDetect = async (countryId) => {
    setLoading(true);
    try {
      const res = await $axios.$get(
        `/vn-travel/hotel-content/provinces?countryId=${countryId}`
      );
      let _provinces = moveToFirst(res.data.data.items, "id", 11); // Hà Nội
      _provinces = moveToFirst(res.data.data.items, "id", 33); // Hồ Chí Minh
      setProvinces(_provinces);
      setFilterProvinces(res.data.data.items);
      const provinceName = _.get(
        _.find(res.data.data.items, (p) => p.name === provinceDetect),
        "name",
        ""
      );
      const countryCode = _.get(
        _.find(countries, (p) => p.id === countryId),
        "code",
        ""
      );
      if (provinceName && countryCode) {
        setFilter({
          ...filter,
          country: countryCode,
          address: provinceName,
        });
        setChooseAddStep(2);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // Hàm phát hiện tỉnh/thành phố
  const detectLocation = async () => {
    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by your browser");
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const placeDetail = await getPlaceDetailFromLatLng(
            latitude,
            longitude
          );

          if (placeDetail) {
            setProvinceDetect(placeDetail.compound.province);
            setCountryDetect(placeDetail.compound.country);
          }
        },
        (err) => {
          console.error("Lỗi khi lấy vị trí: ", err.message);
        }
      );
    } else {
      alert("Trình duyệt không hỗ trợ định vị.");
    }
  };

  const getPlaceDetailFromLatLng = async (lat, lng) => {
    const apiKey = "cohCxpiDQRFycGbEXv2b8UgVB6Li3cnWhsSUGYlW"; // Thay bằng key thật
    const url = `https://rsapi.goong.io/Geocode?latlng=${lat},${lng}&api_key=${apiKey}`;

    try {
      const response = await axios.get(url);
      if (response.data.results && response.data.results.length > 0) {
        const place = response.data.results[0];
        const regionName = formatString(place.compound.province || "");
        const placeDetail = {
          regionName,
          placeName: place.name,
          description: place?.formatted_address || "",
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
          place_id: place.place_id,
          compound: {
            ...place.compound,
            country: place.compound.country || "Việt Nam",
          },
        };
        return placeDetail;
      } else {
        console.warn("Không tìm thấy địa điểm.");
        return null;
      }
    } catch (error) {
      console.error("Lỗi khi gọi API Goong:", error);
      return null;
    }
  };

  const handleGetHotels = async () => {
    setLoading(true);
    try {
      const res = await $axios.$get(
        `/vn-travel/GetHotelMytours?name=&city=${filter.address}&startNumber=${
          _.get(filter, "star", 6) === 6 ? "" : _.get(filter, "star", 6)
        }`
      );
      const _hotels = res.data.data;
      setFilterHotel([{ value: "", name: "Tất cả" }, ..._hotels]);
      setHotels(_hotels);
    } catch (error) {
      setHotels([]);
      notification.error({
        description: `Có lỗi xảy ra vui lòng thử lại!`,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleSearchHotel = async (textSearch) => {
    if (!filter.address && textSearch) {
      notification.warning({
        description: `Vui lòng chọn địa điểm trước!`,
      });
      return;
    }
  };

  const onOpenChange = (type) => {
    setValueCalendar(form.getFieldValue(type) ?? new Date());
    setOpenCalendar(true);
    setTypeCalendar(type);
    if (type === "returnDate") {
      setMinDateCalendar(new Date(form.getFieldValue("departDate")));
    } else {
      setMinDateCalendar(new Date());
    }
  };

  const setValue = (value) => {
    form.setFieldValue(typeCalendar, dayjs(value));
    setValueCalendar(value);
    if (
      typeCalendar === "departDate" &&
      dayjs(value) >= form.getFieldValue("returnDate")
    ) {
      const newReturnDate = dayjs(value).add(1, "day");
      form.setFieldValue("returnDate", newReturnDate);
    }
    setOpenCalendar(false);
  };

  const getAddPrice = async () => {
    try {
      const res = await $axios.$get(`/payment/getAddPrice`);
      if (res.data.data.data.status === 1) {
        setAddPrice(_.get(res, "data.data.data.amount", 0));
      }
    } catch (error) {
    } finally {
    }
  };

  const handleGetListHotelAvailable = async (values) => {
    if (values.numRooms > values.numAdults) {
      notification.warning({
        description: `Số phòng cần nhỏ hơn hoặc bằng số người lớn!`,
      });
      return;
    }
    if (!filter.address) {
      notification.warning({
        description: `Vui lòng chọn tỉnh thành cụ thể!`,
      });
      return;
    }
    setIsSearched(true);
    await handleGetHotels();

    if (!hotelSearch && !hotels.length) {
      setHasMoreHotels(false);
      setDisplayHotels([]);
      setCurrentBatch(0);
      return;
    }

    setCurrentBatch(0);
    setHasMoreHotels(true);
    setDisplayHotels([]);

    // Lấy tất cả ID khách sạn và chia thành các chunk 20 ID
    const allIds = hotelSearch ? [hotelSearch] : hotels.map((h) => h.id);
    const specialHotelId = 29739;
    // Tách riêng hotel đặc biệt
    const specialHotelChunk = allIds.includes(specialHotelId)
      ? [specialHotelId]
      : [];
    const remainingIds = allIds.filter((id) => id !== specialHotelId); // 110 IDs

    // Chia thành các chunk 20 phần tử
    const regularChunks = [];
    for (let i = 0; i < remainingIds.length; i += 20) {
      regularChunks.push(remainingIds.slice(i, i + 20));
    }
    // Combine kết quả
    const chunkedIds = [...[specialHotelChunk], ...regularChunks];
    // Cập nhật state và đợi cho nó được cập nhật
    await new Promise((resolve) => {
      setAllHotelIds(chunkedIds);
      resolve();
    });
    // Tải lần đầu
    await loadMoreHotels(values, chunkedIds);
  };

  const loadMoreHotels = async (values, hotelIdsChunks) => {
    if (!hasMoreHotels) return;

    setLoading(true);
    try {
      const body = {
        StayCheckIn: dayjs(values.departDate).format("YYYY-MM-DD"),
        StayCheckOut: dayjs(values.returnDate).format("YYYY-MM-DD"),
        Nationality: filter.country,
        OccupanciesAdults: values.numAdults + values.numChilds,
        OccupanciesChildren: 0,
        LanguageCode: "vi",
        NumberOfUnits: values.numRooms,
        RealTimeSearch: true,
      };
      // Lấy 5 batch tiếp theo (5 request, mỗi request 20 khách sạn)
      const batchesToFetch = hotelIdsChunks.slice(
        currentBatch,
        currentBatch + 5
      );

      if (batchesToFetch.length === 0) {
        setHasMoreHotels(false);
        return;
      }

      // Gọi API để lấy thông tin phòng trống
      const availabilityResults = await Promise.all(
        batchesToFetch.map((chunk) =>
          $axios
            .$post("/vn-travel/hotel-avail", {
              ...body,
              Hotels: chunk,
            })
            .catch(() => ({ data: { data: { hotels: [] } } }))
        )
      );

      // Lọc các khách sạn có phòng trống
      let newHotels = _.filter(
        _.flatten(
          availabilityResults.map((res) => _.get(res, "data.data.hotels", []))
        ),
        (item) => item.status !== "NoRoom"
      );

      // Nếu có khách sạn mới, lấy thông tin chi tiết
      if (newHotels.length > 0) {
        const propertyChunks = _.chunk(
          newHotels.map((h) => h.id),
          20
        );
        const propertyResults = await Promise.all(
          propertyChunks.map((chunk) => {
            const query = chunk.map((id) => `propertyId=${id}`).join("&");
            return $axios
              .$get(`/vn-travel/hotel-content/properties/content?${query}`)
              .catch(() => ({ data: { data: { items: [] } } }));
          })
        );

        const hotelProperties = _.flatten(
          propertyResults.map((res) => _.get(res, "data.data.items", []))
        );

        const processedHotels = newHotels.map((hotel) => {
          const property = hotelProperties.find((h) => h.id === hotel.id);
          const rooms = property.rooms;
          if (property) {
            delete property.rooms;
          }

          hotel.rooms = hotel.rooms.map((room) => {
            room.info = _.find(rooms, (r) => r.id == room.roomTypeCode) || {};
            room.rates = room.rates.map((rate) => {
              rate["rateAfterTaxTotalNew"] =
                rate["rateAfterTaxTotal"] + addPrice;
              rate["rateBeforeTaxTotalNew"] =
                rate["rateBeforeTaxTotal"] + addPrice;
              return rate;
            });
            room["minPrice"] = _.minBy(
              room.rates,
              "rateAfterTaxTotalNew"
            ).rateAfterTaxTotalNew;
            room["maxPrice"] = _.maxBy(
              room.rates,
              "rateAfterTaxTotalNew"
            ).rateAfterTaxTotalNew;
            return room;
          });
          hotel["minPrice"] = Math.min(...hotel.rooms.map((r) => r.minPrice));
          hotel["maxPrice"] = Math.max(...hotel.rooms.map((r) => r.maxPrice));
          return _.merge({}, hotel, property ? property : {});
        });

        // Gộp với danh sách hiện tại và sắp xếp
        const mergedHotels = [...displayHotels, ...processedHotels];
        const sortedHotels = _.orderBy(
          mergedHotels,
          ["maxPrice"],
          sortBy.includes("price:asc") ? "asc" : "desc"
        );

        setDisplayHotels(sortedHotels);
        // Sử dụng hàm callback để đảm bảo cập nhật chính xác
        setCurrentBatch((prev) => {
          const newBatch = prev + batchesToFetch.length;
          // Kiểm tra xem còn khách sạn nào không
          if (newBatch >= hotelIdsChunks.length) {
            setHasMoreHotels(false);
          }
          return newBatch;
        });
      } else {
        // Nếu không có khách sạn mới, kiểm tra xem đã load hết chưa
        setCurrentBatch((prev) => {
          const newBatch = prev + batchesToFetch.length;
          if (newBatch >= hotelIdsChunks.length) {
            setHasMoreHotels(false);
          }
          return newBatch;
        });
        setLoading(false);
      }
    } catch (error) {
      console.error("Lỗi khi tải thêm khách sạn:", error);
    } finally {
      setLoading(false);
      // if (currentBatch === 0) {
      //   setSearched(true);
      // }
    }
  };

  const getProvinces = async (countryId) => {
    setLoadingLocation(true);
    try {
      const res = await $axios.$get(
        `/vn-travel/hotel-content/provinces?countryId=${countryId}`
      );
      let _provinces = moveToFirst(res.data.data.items, "id", 11); // Hà Nội
      _provinces = moveToFirst(res.data.data.items, "id", 33); // Hồ Chí Minh
      setProvinces(_provinces);
      setFilterProvinces(res.data.data.items);
    } catch (error) {
    } finally {
      setLoadingLocation(false);
    }
  };

  const getCountries = async () => {
    setLoading(true);
    try {
      const res = await $axios.$get(`/vn-travel/hotel-content/countries`);
      const _countries = moveToFirst(res.data.data.items, "id", 1);
      setCountries(_countries);
      setFilterCountries(_countries);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAdd = (value, type = "country" | "province") => {
    if (type === "hotel") {
      setHotelSearch(value);
      setOpenDrawerChooseHotel(false);
      setSearchTermHotel("");
      setFilterHotel([{ value: "", name: "Tất cả" }, ...hotels]);
      return;
    }
    if (type === "country") {
      setChooseAddStep(2);
      getProvinces(value);
      setFilter({
        ...filter,
        country: _.find(countries, (c) => c.id === value).code,
        address: "",
      });
    } else {
      setOpenDrawerChooseAdd(false);
      setFilter({
        ...filter,
        address: _.get(
          _.find(provinces, (c) => c.id === value),
          "name"
        ),
      });
    }
    setSearchTerm("");
  };

  const handleSortPriceHotel = () => {
    const _displayHotels = _.cloneDeep(displayHotels);
    if (sortBy === "price:desc") {
      setDisplayHotels(_.orderBy(_displayHotels, ["maxPrice"], "asc"));
      setSortBy("price:asc");
    } else {
      setDisplayHotels(_.orderBy(_displayHotels, ["maxPrice"], "desc"));
      setSortBy("price:desc");
    }
  };

  const handleSortStarHotel = () => {
    const _displayHotels = _.cloneDeep(displayHotels);
    if (sortBy === "star:desc") {
      setDisplayHotels(_.orderBy(_displayHotels, ["starNumber"], "asc"));
      setSortBy("star:asc");
    } else {
      setDisplayHotels(_.orderBy(_displayHotels, ["starNumber"], "desc"));
      setSortBy("star:desc");
    }
  };

  return (
    <div className="flex flex-col items-center mt-[0px] booking absolute left-1/2 transform -translate-x-1/2 w-full pb-[64px] top-[180px]">
      <CalendarCustom
        openCalendar={openCalendar}
        setOpenCalendar={setOpenCalendar}
        typeCalendar={typeCalendar}
        form={form}
        valueCalendar={valueCalendar}
        setValue={setValue}
        minDate={minDateCalendar}
      />

      <Form
        form={form}
        onFinish={handleGetListHotelAvailable}
        layout="vertical"
        onFinishFailed={(values) => {
          console.log(values, "values");
        }}
        initialValues={{
          departDate: dayjs().add(1, "day"),
          returnDate: dayjs().add(2, "day"),
          startNumber: 0,
        }}
        className="w-[92%] mt-4"
      >
        <div
          style={{
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          }}
          className="rounded-2xl bg-accent"
        >
          <div
            style={{
              boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" bg-white p-4 rounded-2xl"
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col">
                <div className="text-secondary text-[14px] my-1 font-medium">
                  Điểm đến
                </div>
                <Input
                  placeholder="Địa điểm"
                  className="h-[48px] bg-[#f5f6f6] font-normal text-[16px] text-[#333333] address-input focus:border-primary"
                  readOnly
                  prefix={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      className="text-primary"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1_737)">
                        <path
                          d="M16.875 7.52969C16.875 12.1875 10 19.0625 10 19.0625C10 19.0625 3.125 12.1875 3.125 7.52969C3.125 3.16031 6.67781 0.625 10 0.625C13.3222 0.625 16.875 3.16031 16.875 7.52969Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                        <path
                          d="M10 10C11.3807 10 12.5 8.88071 12.5 7.5C12.5 6.11929 11.3807 5 10 5C8.61929 5 7.5 6.11929 7.5 7.5C7.5 8.88071 8.61929 10 10 10Z"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="square"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_737">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                  onClick={() => {
                    setOpenDrawerChooseAdd(true);
                  }}
                  value={filter.address}
                />
              </div>

              <div className="flex flex-col">
                <div className="text-secondary text-[14px] my-1 font-medium">
                  Tên khách sạn
                </div>
                <Input
                  placeholder="Tên khách sạn"
                  className="h-[48px] bg-[#f5f6f6] font-normal text-[16px] text-[#333333] address-input focus:border-[#01ad53]"
                  readOnly
                  onClick={() => {
                    setOpenDrawerChooseHotel(true);
                  }}
                  value={_.get(
                    _.find(filterHotel, ["id", hotelSearch]),
                    "name",
                    ""
                  )}
                />
              </div>
            </div>

            <Row gutter={12} className="my-4">
              <Col span={12}>
                <div className="text-secondary text-[14x] mb-2 font-medium">
                  Ngày nhận phòng
                </div>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn ngày nhận phòng!",
                    },
                  ]}
                  name="departDate"
                  className="w-full mb-0"
                >
                  <DatePicker
                    className="w-full h-[48px]"
                    placeholder="Chọn ngày"
                    format="DD/MM/YYYY"
                    minDate={dayjs()}
                    allowClear={false}
                    locale={locale} // Thiết lập locale tiếng Việt
                    suffixIcon={
                      <svg
                        className="text-primary w-[18px]"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_120_8739)">
                          <path
                            d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_120_8739">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    }
                    open={false}
                    onOpenChange={() => onOpenChange("departDate")}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <div className="text-secondary text-[14px] mb-2 font-medium">
                  Ngày trả phòng
                </div>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn ngày trả phòng!",
                    },
                  ]}
                  name="returnDate"
                  className="w-full mb-0"
                >
                  <DatePicker
                    className="w-full h-[48px]"
                    placeholder="Chọn ngày"
                    format="DD/MM/YYYY"
                    minDate={dayjs()}
                    allowClear={false}
                    locale={locale} // Thiết lập locale tiếng Việt
                    suffixIcon={
                      <svg
                        className="text-primary w-[18px]"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_120_8739)">
                          <path
                            d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                            fill="currentColor"
                          />
                          <path
                            d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_120_8739">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    }
                    open={false}
                    onOpenChange={() => onOpenChange("returnDate")}
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="flex w-full gap-4 justify-between mb-2">
              <div className="w-1/3">
                <CustomInputNumber
                  form={form}
                  name="numAdults"
                  label={
                    <span className="mb-1 text-[14px] font-medium text-secondary flex gap-2">
                      <img src="/images/aldult.svg" alt="" />
                      Người lớn
                    </span>
                  }
                  min={1}
                  max={10}
                  defaultValue={1}
                />
              </div>

              <div className="w-1/3">
                <CustomInputNumber
                  form={form}
                  name="numChilds"
                  label={
                    <span className="mb-1 text-[14px] font-medium text-secondary flex gap-2">
                      <img src="/images/child.svg" alt="" />
                      Trẻ em
                    </span>
                  }
                  min={0}
                  max={10}
                  defaultValue={1}
                />
              </div>

              <div className="w-1/3">
                <CustomInputNumber
                  form={form}
                  name="numRooms"
                  label={
                    <span className="mb-1 text-[14px] font-medium text-secondary flex gap-2">
                      <img src="/images/icon-room.svg" alt="" />
                      Số phòng{" "}
                    </span>
                  }
                  min={1}
                  max={1000}
                  defaultValue={1}
                />
              </div>
            </div>

            <Button
              type="primary"
              htmlType="submit"
              className="w-full h-[48px] mt-4 bg-primary hover:bg-primary"
            >
              <span className="text-[16px] font-semibold">Tìm kiếm</span>
            </Button>
          </div>
          <div className="py-5 px-4 rounded-ee-2xl rounded-es-2xl flex justify-between items-center">
            <span className="font-semibold"> Bạn đã có mã đơn hàng? </span>
            <Button
              onClick={() => setStep("history")}
              variant="outlined"
              className="bg-transparent rounded-lg w-[113px] h-[36px] border-[1px] border-solid border-primary text-primary"
            >
              <span className="text-[16px] font-semibold">Tra cứu ngay</span>
            </Button>
          </div>
        </div>
      </Form>

      <div className="text-center mt-4">
        <span className="text-[#808080] font-normal">
          Hotline hỗ trợ khách hàng{" "}
        </span>
        <a href="tel:1900255585" className="font-bold text-primary text-[16px]">
          1900255585
        </a>
      </div>
      {/* {displayHotels.length > 0 && (
        <div
          className="bg-white p-4 text-center items-center flex mt-4 rounded-[12px] w-[92%] gap-3"
          style={{
            boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
            justifyContent: "space-around",
          }}
        >
          <Button
            className="bg-primary border-[#d9d9d9] text-white focus:bg-white hover:bg-white rounded-[20px]"
            onClick={() => handleSortPriceHotel()}
          >
            {sortBy === "price:asc" && (
              <FontAwesomeIcon
                icon={faArrowUp}
                className="w-[14px]"
                color="#0064D2"
              />
            )}
            {sortBy === "price:desc" && (
              <FontAwesomeIcon
                icon={faArrowDown}
                className="w-[14px]"
                color="#0064D2"
              />
            )}
            <span className="text-whte">Giá</span>
          </Button>

          <Button
            className="bg-primary border-[#d9d9d9] text-white focus:bg-white hover:bg-white rounded-[20px]"
            onClick={() => handleSortStarHotel()}
          >
            {sortBy === "star:asc" && (
              <FontAwesomeIcon
                icon={faArrowUp}
                className="w-[14px]"
                color="#0064D2"
              />
            )}
            {sortBy === "star:desc" && (
              <FontAwesomeIcon
                icon={faArrowDown}
                className="w-[14px]"
                color="#0064D2"
              />
            )}
            <span className="text-white">Hạng khách sạn</span>
          </Button>
        </div>
      )} */}

      {isSearched ? (
        <>
          {displayHotels && displayHotels.length > 0 ? (
            <div className="mt-4 w-[92%]">
              {displayHotels.map((item, index) => (
                <HotelItem
                  key={index}
                  setOpenChooseHotel={setOpenChooseHotel}
                  data={item}
                  setHotelSelected={setHotelSelected}
                  addPrice={addPrice}
                />
              ))}
            </div>
          ) : (
            <>
              {!loading && !hasMoreHotels && displayHotels.length === 0 && (
                <div className="flex flex-col w-[92%] items-center mt-[48px]">
                  <div className="text-[24px] text-primary font-bold text-center mb-2">
                    Không tìm thấy khách sạn trên Ipass
                  </div>
                  <div className="mb-4 text-center text-primary">
                    Hiện tại <span className="font-bold">Ipass</span> chưa cập
                    nhật phòng khách sạn tại{" "}
                    <span className="font-bold">{filter.address}</span> từ ngày
                    <span className="font-bold">
                      {" "}
                      {dayjs(form.getFieldValue("departDate")).format(
                        "DD-MM-YYYY"
                      )}
                    </span>{" "}
                    đến ngày
                    <span className="font-bold">
                      {" "}
                      {dayjs(form.getFieldValue("returnDate")).format(
                        "DD-MM-YYYY"
                      )}
                    </span>
                  </div>
                  <div className="mb-4 text-center text-primary">
                    Xin quý khách vui lòng tìm phòng với ngày khác hoặc thay đổi
                    địa điểm tìm kiếm.
                  </div>
                  <Empty description={""} />
                </div>
              )}
            </>
          )}

          {hasMoreHotels && (
            <div className="flex justify-center mt-4">
              <Button
                type="primary"
                loading={loading}
                size="large"
                onClick={() =>
                  loadMoreHotels(form.getFieldsValue(), allHotelIds)
                }
                className="bg-primary hover:bg-primary"
              >
                <span className="text-[16px] font-semibold">Xem thêm</span>
              </Button>
            </div>
          )}
        </>
      ) : (
        <div className="mt-4 w-[92%]">
          {defaultHotel.map((item, index) => (
            <HotelItem
              key={index}
              setOpenChooseHotel={setOpenChooseHotel}
              data={item}
              setHotelSelected={setHotelSelected}
              addPrice={addPrice}
            />
          ))}
        </div>
      )}
      {openChooseHotel && (
        <ChooseHotel
          hotelSelected={hotelSelected}
          open={openChooseHotel}
          addPrice={addPrice}
          setOpenChooseHotel={setOpenChooseHotel}
          setLoading={setLoading}
          formSearch={form}
          setHotelSelected={setHotelSelected}
          filterSearch={filter}
        />
      )}

      {openDrawerChooseHotel && (
        <div className="location">
          <Drawer
            title={
              <h1 className="text-lg font-bold text-white">Chọn khách sạn</h1>
            }
            placement="bottom"
            open={openDrawerChooseHotel}
            onClose={() => {
              setTimeout(() => {
                setOpenDrawerChooseHotel(false);
              }, 0);
            }}
            height="100vh"
          >
            <div className="custom-scroll pb-[64px]">
              <Input
                placeholder="Tìm kiếm khách sạn"
                value={searchTermHotel}
                onChange={(e) => {
                  setSearchTermHotel(e.target.value);
                }}
                className="mb-2"
              />
              <div className="overflow-auto airport-list">
                {filterHotel.length > 0 ? (
                  <>
                    <h4 className="mb-2 font-semibold text-md text-primary">
                      Chọn khách sạn
                    </h4>
                    <div className="flex gap-2.5 flex-wrap">
                      {filterHotel.map((c) => (
                        <div
                          key={c.id}
                          className="h-8 flex items-center rounded-lg px-2 bg-[#EDF2F7]"
                          onClick={() => handleSelectAdd(c.id, "hotel")}
                        >
                          {c?.name}
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <Empty description={"Không có dữ liệu"} />
                )}
              </div>
            </div>
            {contextHolder}
          </Drawer>
        </div>
      )}

      {openDrawerChooseAdd && (
        <div className="location">
          <Drawer
            title={
              <h1 className="text-lg font-bold text-white">
                {chooseAddStep === 1 ? "Chọn đất nước" : "Chọn tỉnh thành"}
              </h1>
            }
            placement="bottom"
            open={openDrawerChooseAdd}
            onClose={() => {
              setTimeout(() => {
                setOpenDrawerChooseAdd(false);
              }, 0);
            }}
            height="100vh"
            loading={loadingLocation}
          >
            {chooseAddStep === 2 && (
              <div
                className="w-full bg-white  text-primary mb-4"
                onClick={() => setChooseAddStep(1)}
              >
                <FontAwesomeIcon icon={faAngleLeft} className="text-primary" />
                <span className="text-[16px]">Quay lại</span>{" "}
              </div>
            )}
            <div className="custom-scroll pb-[64px]">
              {(chooseAddStep === 1 && countries.length > 0) ||
              (chooseAddStep === 2 && provinces.length > 0) ? (
                <Input
                  placeholder="Tìm kiếm địa điểm"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  className="mb-2"
                />
              ) : (
                <Empty description={"Không có dữ liệu"} />
              )}

              <div className="overflow-auto airport-list">
                {filterCountries.length > 0 && chooseAddStep === 1 && (
                  <>
                    <h4 className="mb-2 font-semibold text-md text-primary">
                      Chọn đất nước
                    </h4>
                    <div className="flex gap-2.5 flex-wrap">
                      {filterCountries.map((c) => (
                        <div
                          key={c.id}
                          className="h-8 flex items-center rounded-lg px-2 bg-[#EDF2F7]"
                          onClick={() => handleSelectAdd(c.id, "country")}
                        >
                          {c?.name}
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {filterProvinces.length > 0 && chooseAddStep === 2 && (
                  <div className="mt-4">
                    <h4 className="mb-2 font-semibold text-md text-primary">
                      Tỉnh/Thành phố
                    </h4>
                    <div className="flex gap-2.5 flex-wrap">
                      {filterProvinces.map((item) => (
                        <div
                          key={item.id}
                          className="h-8 flex items-center rounded-lg px-2 bg-[#EDF2F7]"
                          onClick={() => handleSelectAdd(item.id, "province")}
                        >
                          {item?.name}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {contextHolder}
          </Drawer>
        </div>
      )}
    </div>
  );
};

export default Booking;
